<template>
  <vs-popup title="필수입력사항 안내" :active.sync="showPopup" id="RequiredFieldDialog">
    <ul class="messages">
      <li
        v-for="(msg, idx) in messages"
        :key="idx"
        class="message-item"
        :class="{ clickable: !!msg.action }"
        @click="handleItemClick(msg)"
      >
        <feather-icon icon="AlertCircleIcon" svgClasses="w-4 h-4" class="message-icon" />
        <div class="message-text">
          <div>{{ msg.text }}</div>
          <div v-if="msg.sub" class="message-sub">{{ msg.sub }}</div>
        </div>
        <feather-icon v-if="msg.action" icon="ChevronsRightIcon" svgClasses="w-4 h-4" class="message-arrow" />
      </li>
    </ul>
    <div class="flex justify-end mt-4">
      <vs-button color="secondary" @click="handleClose">확인</vs-button>
    </div>
  </vs-popup>
</template>

<script>
export default {
  data() {
    return {
      showPopup: false,
      messages: [],
    };
  },
  mounted() {
    window.addEventListener("requiredFieldAlert", this.open);
  },
  beforeDestroy() {
    window.removeEventListener("requiredFieldAlert", this.open);
  },
  methods: {
    open(event) {
      const { messages } = event.detail || {};
      this.messages = Array.isArray(messages) ? messages : [];
      this.showPopup = true;
    },
    handleClose() {
      this.showPopup = false;
      this.messages = [];
    },
    handleItemClick(msg) {
      if (!msg.action) return;
      this.handleClose();
      this.$nextTick(() => {
        setTimeout(msg.action, 200);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.messages {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.message-item {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  font-size: 14px;
  line-height: 1.5;
  border-radius: 4px;
  padding: 2px 4px;
  margin: 0 -4px;

  &.clickable {
    cursor: pointer;
    &:hover {
      background: #f0eeff;
      .message-arrow { color: #7e72f2; }
    }
  }
}

.message-icon {
  flex-shrink: 0;
  margin-top: 2px;
  color: #555;
}

.message-text {
  flex: 1;
}

.message-sub {
  padding-left: 0;
  margin-top: 2px;
  color: #555;
}

.message-arrow {
  flex-shrink: 0;
  margin-top: 2px;
  color: #bbb;
  margin-left: auto;
}
</style>
